import React, { useMemo } from 'react';
import { FrameOrientation } from 'src/types';

import ComponentTable from './component-table';
import ProjectFrameWrapper from './project-frame-wrapper';
import TitleBlock from './title-block';

interface IProps {
  wrapWidth: number;
  orientation: FrameOrientation;
}

/**
 * Base width for A4 landscape (1123px)
 */
const BASE_WIDTH = 1123;

function ProjectFrameOverlay({ wrapWidth, orientation }: IProps) {
  // Calculate scale factor based on wrapWidth
  const scale = useMemo(() => wrapWidth / BASE_WIDTH, [wrapWidth]);

  const border = useMemo(() => '1px solid #1f2937', []);

  return (
    <div
      className="absolute inset-0"
      style={{
        fontSize: `${12 * scale}px`,
        border,
      }}
    >
      {/* Main drawing area border */}
      <div
        className="absolute"
        style={{
          top: `${40 * scale}px`,
          left: 0,
          right: 0,
          bottom: `${120 * scale}px`,
        }}
      />
      <ProjectFrameWrapper
        scale={scale}
        orientation={orientation}
        border={border}
      />
      <div
        className="border-b border-t border-gray-300"
        style={{
          width: '100%',
          height: '100%',
          padding: `${15 * scale}px`,
        }}
      >
        <div className="relative h-full w-full" style={{ border }}>
          {/* <HeaderBlock scale={scale} border={border} /> */}
          <TitleBlock scale={scale} border={border} />
          <ComponentTable scale={scale} border={border} />
        </div>
      </div>
    </div>
  );
}

export default React.memo(ProjectFrameOverlay);
